import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import {
  Feature,
  FeatureRepository,
  FeatureDescriptionDto,
} from './feature.repository';
import { RenameTenantMenuItemDto } from 'app/api/models/features/renameTenantMenuItemDto';

const API = '/api/features';

@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  constructor(private http: HttpClient, protected repo: FeatureRepository) {}

  load() {
    return this.http.get<Feature[]>(API).pipe(
      tap((res) => this.repo.set(res)),
      this.repo.track(),
      this.repo.skipWhileCached()
    );
  }

  loadFeatures(tenantId: string) {
    return this.http.get<Feature[]>(`${API}/featuresFilter/${tenantId}`).pipe(
      tap((res) => {
        console.log(res);
        this.repo.set(res);
      }),
      this.repo.track(),
      this.repo.skipWhileCached()
    );
  }

  getItemsToRename(id: string) {
    return this.http.get<RenameTenantMenuItemDto[]>(`${API}/${id}`);
  }

  updateFeatures(id: string, tenant: Partial<FeatureDescriptionDto>[]) {
    return this.http.patch<any[]>(`${API}/${id}`, tenant);
  }
}
